export type WhatsappProof = {
  name: string
  role: string
  highlight: string
  image: string
  alt: string
}

export const whatsapps: WhatsappProof[] = [
  {
    name: 'Profe Seba',
    role: 'Pack Fútbol 11',
    highlight: '"Me ahorró un montón de tiempo. Está todo muy ordenado."',
    image:
      'https://cdn.magicpatterns.com/uploads/4f2BEjvetX5QgvgnTF6knL/ChatGPT_Image_19_ago_2026,_05_44_43_p.m..png',
    alt: 'Captura de WhatsApp del Profe Seba agradeciendo por el pack de fútbol 11 y contando que los ejercicios de posesión y juegos reducidos le sirvieron mucho',
  },
  {
    name: 'DT Maxi',
    role: 'Pack Fútbol 11',
    highlight: '"Ayer hicimos un entrenamiento por líneas y salió espectacular."',
    image:
      'https://cdn.magicpatterns.com/uploads/5cQ2my9R7GEGLmDAHB3Dzu/ChatGPT_Image_19_ago_2026,_05_44_45_p.m..png',
    alt: 'Captura de WhatsApp del DT Maxi contando que ya aplicó varios ejercicios del pack y que se lo recomendó a otro DT del club',
  },
  {
    name: 'Profe Fede',
    role: 'Pack Fútbol 11',
    highlight: '"Muy claro y fácil de aplicar. Los chicos se coparon mucho."',
    image:
      'https://cdn.magicpatterns.com/uploads/2f7tkqpRLBuFqqZ6txu9aV/ChatGPT_Image_19_ago_2026,_05_44_48_p.m..png',
    alt: 'Captura de WhatsApp del Profe Fede diciendo que el pack le facilitó la planificación y que hizo dos ejercicios de posesión y uno de definición',
  },
]
